import { render, staticRenderFns } from "./ProjectTemplateViewModal.vue?vue&type=template&id=1e6ab190&"
import script from "./ProjectTemplateViewModal.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplateViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports